// Generated from packages/workflow-builder/iconConverter.js
import { SvgIconProps, createSvgIcon } from '@automata/mui-theme';
import { BrokenImageOutlined as BrokenImageOutlinedIcon } from '@automata/mui-theme/icons';
import { logger } from '@automata/utils';
import { memo } from 'react';

import { conditionalFlowIcon } from './conditionalFlowIcon';
import { labwareIcon } from './labwareIcon';
import { processDataIcon } from './processDataIcon';
import { rocketIcon } from './rocketIcon';
import { taskDependencyIcon } from './taskDependencyIcon';
import { taskIcon } from './taskIcon';

export {
  labwareIcon,
  processDataIcon,
  taskIcon,
  taskDependencyIcon,
  conditionalFlowIcon,
  rocketIcon,
};

export const getIcon = (iconName: string): ReturnType<typeof createSvgIcon> => {
  switch (iconName) {
    case 'labware':
      return labwareIcon;
    case 'processdata':
      return processDataIcon;
    case 'task':
      return taskIcon;
    case 'taskdependency':
      return taskDependencyIcon;
    case 'conditionalflow':
      return conditionalFlowIcon;
    case 'rocketIcon':
      return rocketIcon;
    default:
      logger.log(`no icon for iconName ${iconName}`);
      return BrokenImageOutlinedIcon;
  }
};

export const Icon = memo(function Memoized({
  iconType,
  ...otherProps
}: SvgIconProps & { iconType: string }) {
  const Icon = getIcon(iconType.replace(/[-_]/g, ''));
  return <Icon style={{ fill: 'currentColor' }} {...otherProps} />;
});
